var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContacts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.002,
    height: 20.742,
    viewBox: "0 0 20.002 20.742",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "contacts",
    d: "M122.78,35H109.445a2.222,2.222,0,0,0-2.222,2.222v.741h-1.482a.741.741,0,1,0,0,1.482h1.482V44.63h-1.482a.741.741,0,1,0,0,1.482h1.482V51.3h-1.482a.741.741,0,1,0,0,1.482h1.482v.741a2.222,2.222,0,0,0,2.222,2.222H122.78A2.222,2.222,0,0,0,125,53.52v-16.3A2.222,2.222,0,0,0,122.78,35Zm.741,18.52a.741.741,0,0,1-.741.741H109.445a.741.741,0,0,1-.741-.741v-.741h.741a.741.741,0,1,0,0-1.482H108.7V46.112h.741a.741.741,0,1,0,0-1.482H108.7V39.445h.741a.741.741,0,1,0,0-1.482H108.7v-.741a.741.741,0,0,1,.741-.741H122.78a.741.741,0,0,1,.741.741Zm-7.408-9.63a2.963,2.963,0,1,0-2.1-.868A2.963,2.963,0,0,0,116.112,43.89Zm0-4.445a1.481,1.481,0,1,1-1.048.434A1.482,1.482,0,0,1,116.112,39.445Zm0,5.186a5.186,5.186,0,0,0-5.186,5.186V51.3a.741.741,0,0,0,.741.741h8.89a.741.741,0,0,0,.741-.741V49.816a5.186,5.186,0,0,0-5.186-5.186Zm3.7,5.926h-7.408v-.741a3.7,3.7,0,0,1,7.408,0Z",
    transform: "translate(-105 -35)",
    fill: "#bebfb6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContacts);
export default __webpack_public_path__ + "static/media/contacts.3c1390b341492315dda96435c86f5976.svg";
export { ForwardRef as ReactComponent };